import { updateObject } from '../../helpers/utility.helper';
import { initialState } from '../state/user.state';
import userType from '../types/user.type';
import IUserState from '../models/IUserState';

const getAllUserStart = (oldState: IUserState, action: any) => {
    return updateObject(oldState, {
        userList: updateObject(oldState.userList, {
            error: null, loading: true
        })
    });
};

const getAllUserSuccess = (oldState: IUserState, action: any) => {
    return updateObject(oldState, {
        userList: updateObject(oldState.userList, {
            users: action.payload,
            error: null,
            loading: false
        })
    });
};

const getAllUserError = (oldState: IUserState, action: any) => {
    return updateObject(oldState, {
        userList: updateObject(oldState.userList, {
            error: action.payload,
            loading: false
        })
    });
};

const deleteUserStart = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        deleteUser:updateObject(oldState.deleteUser, {
        loading: true
        })
    });
};

const deleteUserSuccess = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        deleteUser:updateObject(oldState.deleteUser, {
        success:true,
        error: null,
	    loading: false        
        })
    });
};

const deleteUserError = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        deleteUser:updateObject(oldState.deleteUser, {
        success:false,
        error: action.payload,
	    loading: false
        })
    });
};

const resetDeleteUserState = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        deleteUser:initialState.deleteUser
    });
};

const addUserStart = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        addUser:updateObject(oldState.addUser, {
        loading: true,
        success:false,
        error: null
        })
    });
};

const addUserSuccess = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        addUser:updateObject(oldState.addUser, {
        success:true,
        error: null,
	    loading: false        
        })
    });
};

const addUserError = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        addUser:updateObject(oldState.addUser, {
        success:false,
        error: action.payload,
	    loading: false
        })
    });
};

const resetAddUserState = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        addUser:initialState.addUser
    });
};

const getUserByIdStart = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        user:updateObject(oldState.user, {
        loading: true
        })
    });
};

const getUserByIdSuccess = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        user:updateObject(oldState.user, {
        user:action.payload,
        error: null,
	    loading: false        
        })
    });
};

const getUserByIdError = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        user:updateObject(oldState.user, {
        user:null,
        error: 'Some Error Occured',
	    loading: false
        })
    });
};

const resetGetUserByIdState = (oldState:IUserState, action: any) => {
	return updateObject(oldState, {
        user:initialState.user
    });
};

//user devices

const userDevicesStart = (oldState: IUserState, action: any) => {
    return updateObject(oldState, {
        userDevices: updateObject(oldState.userDevices, {
            loading: true,
            success: false,
            error: null
        })
    });
};

const userDevicesSuccess = (oldState: IUserState, action: any) => {
    return updateObject(oldState, {
        userDevices: updateObject(oldState.userDevices, {
            devices:action.payload,
            error: null,
            loading: false
        })
    });
};

const userDevicesError = (oldState: IUserState, action: any) => {
    return updateObject(oldState, {
        userDevices: updateObject(oldState.userDevices, {
            success: false,
            error: action.payload,
            loading: false
        })
    });
};

const resetUserDevicesState = (oldState: IUserState, action: any) => {
    return updateObject(oldState, {
        userDevices: initialState.userDevices
    });
};

const userReducer = (oldState: IUserState = initialState, action: any) => {
    switch (action.type) {
        case userType.GET_ALL_USER_START: return getAllUserStart(oldState, action);
        case userType.GET_ALL_USER_SUCCESS: return getAllUserSuccess(oldState, action);
        case userType.GET_ALL_USER_ERROR: return getAllUserError(oldState, action);
        case userType.DELETE_USER_START: return deleteUserStart(oldState, action);
        case userType.DELETE_USER_SUCCESS: return deleteUserSuccess(oldState, action);
        case userType.DELETE_USER_ERROR: return deleteUserError(oldState, action);
        case userType.RESET_DELETE_USER_STATE: return resetDeleteUserState(oldState, action);
        case userType.ADD_USER_START: return addUserStart(oldState, action);
        case userType.ADD_USER_SUCCESS: return addUserSuccess(oldState, action);
        case userType.ADD_USER_ERROR: return addUserError(oldState, action);
        case userType.RESET_ADD_USER_STATE: return resetAddUserState(oldState, action);
        case userType.GET_USER_BY_ID_START: return getUserByIdStart(oldState, action);
        case userType.GET_USER_BY_ID_SUCCESS: return getUserByIdSuccess(oldState, action);
        case userType.GET_USER_BY_ID_ERROR: return getUserByIdError(oldState, action);
        case userType.RESET_GET_USER_BY_ID_STATE: return resetGetUserByIdState(oldState, action);
        case userType.GET_USER_DEVICES_START: return userDevicesStart(oldState, action);
        case userType.GET_USER_DEVICES_SUCCESS: return userDevicesSuccess(oldState, action);
        case userType.GET_USER_DEVICES_ERROR: return userDevicesError(oldState, action);
        case userType.RESET_USER_DEVICES_STATE: return resetUserDevicesState(oldState, action);

        default: return oldState;
    }
};
export default userReducer;